export function announcementStoreIdForApi(storeLabel) {
  if (!storeLabel || storeLabel === "All Stores") return null;
  return storeLabel;
}

export function announcementEditorQueryParams(user) {
  const editorName = String(user?.name ?? user?.email ?? "").trim();
  const editorRole = String(user?.role ?? "").trim();
  return new URLSearchParams({
    editor_name: editorName,
    editor_role: editorRole,
  });
}

export function announcementFetchStoreParam(user, filterTab) {
  const isCrossStore = user?.role === "admin" || user?.role === "brand_manager" || user?.role === "hr";
  if (filterTab === "All Stores") {
    return isCrossStore ? "All Stores" : (user?.store || "All Stores");
  }
  return filterTab;
}

export function mapAnnouncementFromApi(row) {
  const created = row?.created_at ? String(row.created_at).slice(0, 10) : "";
  const updated = row?.updated_at ? String(row.updated_at).slice(0, 10) : "";
  return {
    id: row.id,
    author: row.published_by,
    role: row.published_by_role,
    store: row.store_id ? row.store_id : "All Stores",
    title: row.title,
    body: row.body,
    date: created,
    editedAt: updated && updated !== created ? updated : null,
    pinned: Boolean(row.is_pinned),
    photo: row.image_url || null,
    expiresAt: row.expires_at || null,
    readByMe: Boolean(row.read_by_me),
    readCount: Number(row.read_count) || 0,
  };
}